module.exports = __webpack_public_path__ + "static/media/informaBanner.08155bdf.png";